import {GET_STATES} from "../../../services/types/StatesTypes";

const initialState = {

    states: []

};

export const StatesReducer=(state=initialState, action) => {

    const {type, payload} = action;
    if (type === GET_STATES) {
        return{

            ...state,
            states: payload

        };

    } else {
        return state;
    }
};

export default StatesReducer